/* Cool Change Co: cart drawer + cart page. Add to cart opens the drawer, everything re-renders in place. */
(function () {
  if (window.CCCart) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false, giftBusy = false;

  function drawer() { return document.querySelector('[data-cc-cart]'); }
  function ids() {
    var out = [];
    var d = drawer(); if (d && d.dataset.sectionId) out.push(d.dataset.sectionId);
    document.querySelectorAll('[data-cc-cart-page]').forEach(function (p) { if (p.dataset.sectionId) out.push(p.dataset.sectionId); });
    return out;
  }
  function parse(htmlText) { return new DOMParser().parseFromString(htmlText, 'text/html'); }

  function render(sections) {
    if (!sections) return;
    var d = drawer();
    if (d && sections[d.dataset.sectionId]) {
      var doc = parse(sections[d.dataset.sectionId]);
      var fresh = doc.querySelector('[data-cc-cart-inner]');
      var cur = d.querySelector('[data-cc-cart-inner]');
      if (fresh && cur) {
        var body = cur.querySelector('.cc-cart__body');
        var scroll = body ? body.scrollTop : 0;
        cur.replaceWith(fresh);
        var nb = fresh.querySelector('.cc-cart__body'); if (nb) nb.scrollTop = scroll;
        var count = fresh.getAttribute('data-count') || '0';
        document.querySelectorAll('[data-cc-count]').forEach(function (c) { c.textContent = count === '0' ? '' : count; });
        initCarousel(fresh);
      }
    }
    document.querySelectorAll('[data-cc-cart-page]').forEach(function (p) {
      var html = sections[p.dataset.sectionId];
      if (!html) return;
      var fp = parse(html).querySelector('[data-cc-cart-page]');
      if (fp) p.replaceWith(fp);
    });
    syncReward();
    checkGift();
  }

  function syncReward() {
    var src = document.querySelector('[data-cc-cart-inner] .cc-cart__reward');
    document.querySelectorAll('[data-cc-reward-slot]').forEach(function (slot) {
      slot.innerHTML = src ? src.outerHTML : '';
      slot.hidden = !src;
    });
  }

  function post(url, body, isForm) {
    var opts = { method: 'POST', headers: { Accept: 'application/json' }, body: body };
    if (!isForm) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(root + url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Cart error'); e.data = j; throw e; } return j; });
    });
  }
  function withSections(body) { body.sections = ids().join(','); body.sections_url = window.location.pathname; return body; }

  function setBusy(on) {
    busy = on;
    var inner = document.querySelector('[data-cc-cart-inner]'); if (inner) inner.classList.toggle('is-busy', on);
    document.querySelectorAll('[data-cc-cart-page]').forEach(function (p) { p.classList.toggle('is-busy', on); });
  }

  var CCCart = {
    open: function () { if (window.CCDrawer && drawer()) window.CCDrawer.open('cc-cart'); },
    refresh: function (open) {
      var list = ids();
      if (!list.length) { if (open) window.location.href = root + 'cart'; return Promise.resolve(); }
      return fetch(root + '?sections=' + list.join(',')).then(function (r) { return r.json(); }).then(function (s) { render(s); if (open) CCCart.open(); });
    },
    change: function (key, qty, line) {
      if (line) line.classList.add('is-busy');
      setBusy(true);
      return post('cart/change.js', withSections({ id: key, quantity: Math.max(0, qty) })).then(function (j) { render(j.sections); })
        .catch(function () { return CCCart.refresh(); }).then(function () { setBusy(false); });
    },
    add: function (items, open) {
      setBusy(true);
      return post('cart/add.js', withSections({ items: items })).then(function (j) { render(j.sections); if (open) CCCart.open(); })
        .catch(function () { return CCCart.refresh(open); }).then(function () { setBusy(false); });
    },
    update: function (data) {
      setBusy(true);
      return post('cart/update.js', withSections(data)).then(function (j) { render(j.sections); return j; })
        .catch(function () { return CCCart.refresh(); }).then(function (j) { setBusy(false); return j; });
    }
  };
  window.CCCart = CCCart;

  /* free gift: add when unlocked, remove when the cart drops below */
  function checkGift() {
    var inner = document.querySelector('[data-cc-cart-inner]');
    if (!inner || giftBusy || inner.getAttribute('data-gift-enable') !== '1') return;
    var ok = inner.getAttribute('data-gift-ok') === '1';
    var line = parseInt(inner.getAttribute('data-gift-line'), 10) || 0;
    var variant = parseInt(inner.getAttribute('data-gift-variant'), 10);
    if (ok && !line && variant) {
      giftBusy = true;
      post('cart/add.js', withSections({ items: [{ id: variant, quantity: 1, properties: { _cc_gift: '1' } }] }))
        .then(function (j) { giftBusy = false; render(j.sections); }).catch(function () { giftBusy = false; });
    } else if (!ok && line) {
      giftBusy = true;
      post('cart/change.js', withSections({ line: line, quantity: 0 }))
        .then(function (j) { giftBusy = false; render(j.sections); }).catch(function () { giftBusy = false; });
    }
  }

  /* one-per-view carousel for frequently added */
  function initCarousel(scope) {
    (scope || document).querySelectorAll('[data-cc-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-cc-car-track]');
      if (!track) return;
      var n = track.children.length, i = 0;
      var prev = c.querySelector('[data-cc-car-prev]'), next = c.querySelector('[data-cc-car-next]');
      function go(k) {
        i = Math.max(0, Math.min(n - 1, k));
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i >= n - 1;
      }
      if (prev) prev.onclick = function () { go(i - 1); };
      if (next) next.onclick = function () { go(i + 1); };
      var sx = 0;
      track.ontouchstart = function (e) { sx = e.touches[0].clientX; };
      track.ontouchend = function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); };
      go(0);
    });
  }

  /* add to cart from any product form */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.querySelector('input[name="return_to"]') || !drawer()) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    fd.append('sections', ids().join(','));
    fd.append('sections_url', window.location.pathname);
    post('cart/add.js', fd, true).then(function (j) { render(j.sections); CCCart.open(); })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* delegated cart controls (drawer + cart page) */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cc-qty-set]');
    if (q) {
      var line = q.closest('[data-cc-line]');
      if (line && !busy) { e.preventDefault(); CCCart.change(line.getAttribute('data-cc-line'), parseInt(q.getAttribute('data-cc-qty-set'), 10), line); }
      return;
    }
    var rm = e.target.closest('[data-cc-discount-remove]');
    if (rm && !busy) {
      var code = rm.getAttribute('data-cc-discount-remove');
      var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      CCCart.update({ discount: codes.join(',') });
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-cc-qty-input]');
    if (inp) {
      var line = inp.closest('[data-cc-line]');
      var v = parseInt(inp.value, 10);
      if (line && !isNaN(v)) CCCart.change(line.getAttribute('data-cc-line'), v, line);
      return;
    }
    var note = e.target.closest('[data-cc-note]');
    if (note) post('cart/update.js', { note: note.value }).catch(function () {});
  });
  function currentCodes() {
    var out = [];
    document.querySelectorAll('[data-cc-cart-inner] [data-cc-discount-remove], [data-cc-cart-page] [data-cc-discount-remove]').forEach(function (b) {
      var c = b.getAttribute('data-cc-discount-remove');
      if (out.indexOf(c) === -1) out.push(c);
    });
    return out;
  }
  document.addEventListener('submit', function (e) {
    var df = e.target.closest('[data-cc-discount]');
    if (df) {
      e.preventDefault();
      var input = df.querySelector('input[name="code"]');
      var code = input ? input.value.trim() : '';
      if (!code || busy) return;
      var codes = currentCodes(); codes.push(code);
      CCCart.update({ discount: codes.join(',') }).then(function (j) {
        var ok = j && j.discount_codes && j.discount_codes.some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
        if (!ok) document.querySelectorAll('[data-cc-discount-err]').forEach(function (m) { m.hidden = false; });
      });
      return;
    }
    var up = e.target.closest('[data-cc-up]');
    if (up) {
      e.preventDefault();
      var idEl = up.querySelector('[name="id"]');
      var b = up.querySelector('.cc-up__add'); if (b) b.classList.add('is-busy');
      if (idEl) CCCart.add([{ id: parseInt(idEl.value, 10), quantity: 1 }], false);
    }
  });

  function init() { initCarousel(); syncReward(); checkGift(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initCarousel(); });
})();
